"use strict"; // Copyright 2019 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var _regeneratorRuntime = require("C:\\Users\\vince\\repositories\\SKS-2019\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\vince\\repositories\\SKS-2019\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _classCallCheck = require("C:\\Users\\vince\\repositories\\SKS-2019\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\vince\\repositories\\SKS-2019\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NodeCrypto = void 0;

var crypto = require("crypto");

var NodeCrypto =
/*#__PURE__*/
function () {
  function NodeCrypto() {
    _classCallCheck(this, NodeCrypto);
  }

  _createClass(NodeCrypto, [{
    key: "sha256DigestBase64",
    value: function () {
      var _sha256DigestBase = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(str) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", crypto.createHash('sha256').update(str).digest('base64'));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function sha256DigestBase64(_x) {
        return _sha256DigestBase.apply(this, arguments);
      }

      return sha256DigestBase64;
    }()
  }, {
    key: "randomBytesBase64",
    value: function randomBytesBase64(count) {
      return crypto.randomBytes(count).toString('base64');
    }
  }, {
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(pubkey, data, signature) {
        var verifier;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                verifier = crypto.createVerify('sha256');
                verifier.update(data);
                verifier.end();
                return _context2.abrupt("return", verifier.verify(pubkey, signature, 'base64'));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function verify(_x2, _x3, _x4) {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(privateKey, data) {
        var signer;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                signer = crypto.createSign('RSA-SHA256');
                signer.update(data);
                signer.end();
                return _context3.abrupt("return", signer.sign(privateKey, 'base64'));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function sign(_x5, _x6) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }, {
    key: "decodeBase64StringUtf8",
    value: function decodeBase64StringUtf8(base64) {
      return Buffer.from(base64, 'base64').toString('utf-8');
    }
  }, {
    key: "encodeBase64StringUtf8",
    value: function encodeBase64StringUtf8(text) {
      return Buffer.from(text, 'utf-8').toString('base64');
    }
  }]);

  return NodeCrypto;
}();

exports.NodeCrypto = NodeCrypto;